import { ApiError } from '../../abstract/api-error';
import { ExistingUser } from '../response-models/existing-user.model';
import { isRecord } from './is-record';
import { nullableString } from './wire-value-utils';

/** The hub's error code when a create-user request names an email that already has a profile. */
export const USER_ALREADY_EXISTS = 'USER_ALREADY_EXISTS';

/**
 * The existing user from a `USER_ALREADY_EXISTS` error (`ApiError.detail.existingUser`), or `null` for any
 * other error. Accepts whatever was thrown; it is mapped through `ApiError.fromHttpError`.
 */
export function existingUserFromError(error: unknown): ExistingUser | null {
  const apiError = ApiError.fromHttpError(error);
  if (apiError.code !== USER_ALREADY_EXISTS || !isRecord(apiError.detail)) {
    return null;
  }
  const user = apiError.detail['existingUser'];
  if (!isRecord(user) || typeof user['id'] !== 'string') {
    return null;
  }
  return {
    id: user['id'],
    email: nullableString(user['email']) ?? null,
    firstName: nullableString(user['firstName']) ?? null,
    lastName: nullableString(user['lastName']) ?? null,
    hasFirebaseAccount: user['hasFirebaseAccount'] === true,
  };
}
